import React, { useState } from 'react';
import './CustomPageNavigation.scss';

const CustomPageNavigation = ({ pages, currentPage, onPageChange, onExpandedChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    const newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);
    // Notify parent component about the expanded state change
    if (onExpandedChange) {
      onExpandedChange(newExpandedState);
    }
  };

  if (!pages || pages.length === 0) {
    return null;
  }

  return (
    <div className={`custom-page-navigation ${isExpanded ? 'expanded' : 'collapsed'}`}>
      {isExpanded ? (
        /* Expanded State - Full sidebar with pages */
        <div className="page-nav-content">
          {/* Header with collapse arrow */}
          <div className="page-nav-header" onClick={toggleExpanded}>
            <i className="fa fa-bars"></i>
            <span className="page-nav-title">Pages</span>
            <i className="fa fa-chevron-left page-nav-collapse-arrow"></i>
          </div>

          {/* Pages List */}
          <div className="page-nav-list">
            {pages.map((page) => (
              <div
                key={page.name}
                className={`page-nav-item ${currentPage?.name === page.name ? 'active' : ''}`}
                onClick={() => onPageChange(page.name)}
              >
                <span className="page-nav-item-text">{page.displayName}</span>
                {currentPage?.name === page.name && (
                  <i className="fa fa-check page-nav-check"></i>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        /* Collapsed State - Arrow at top, then vertical "Pages" text */
        <div className="page-nav-collapsed" onClick={toggleExpanded}>
          <i className="fa fa-chevron-right page-nav-expand-arrow"></i>
          <div className="page-nav-vertical-text">Pages</div>
        </div>
      )}
    </div>
  );
};

export default CustomPageNavigation;
